import { ReplacementLeadReclaimCounts } from 'interfaces/ReplacementLeads'

interface Props {
    title: string
    counts: ReplacementLeadReclaimCounts
}

const share = (value: number, total: number) => (total > 0 ? Math.round((100 * value) / total) : 0)

/**
 * Accepted / open / denied split of a provider's reclaims. Bonus context for the same CS
 * conversation: it covers every lead type, so phone click reclaims are in here too.
 */
const ReclaimStatusBar = ({ title, counts }: Props) => {
    const total = counts.accepted + counts.open + counts.denied

    return (
        <div className="border-t border-grey-200 pt-3">
            <div className="font-bold text-dark mb-2">{title}</div>
            <div className="flex gap-0.5 h-3 rounded-full overflow-hidden bg-grey-200">
                <div
                    className="bg-secondary"
                    style={{ width: `${share(counts.accepted, total)}%` }}
                />
                <div className="bg-goldenrod" style={{ width: `${share(counts.open, total)}%` }} />
                <div className="bg-grey-700" style={{ width: `${share(counts.denied, total)}%` }} />
            </div>
            <div className="flex gap-4 mt-2 text-typography-text-sm text-grey-800">
                <span className="inline-flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-secondary" />
                    <b className="text-dark">{counts.accepted}</b> accepted
                    {total > 0 && (
                        <span className="text-grey-700">({share(counts.accepted, total)}%)</span>
                    )}
                </span>
                <span className="inline-flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-goldenrod" />
                    <b className="text-dark">{counts.open}</b> open
                </span>
                <span className="inline-flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-grey-700" />
                    <b className="text-dark">{counts.denied}</b> denied
                    {total > 0 && (
                        <span className="text-grey-700">({share(counts.denied, total)}%)</span>
                    )}
                </span>
            </div>
        </div>
    )
}

export default ReclaimStatusBar
